/*
 * 作品案例-列表组件
 * @author: linbenjian
 * @date: 2018-07-13 14:56:43
 */
import './search-list.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkInViewport } from '@fe/common/lib/node';
import throttle from '@fe/common/lib/throttle';
import EmptyTip from 'components/app-case/app-case-search/empty';
import ListItem from 'components/app-case/list-item';
import CaseList from 'containers/app-case/case-list';
import BottomStatus from './bottom-status';
// import GotoTop from 'components/goto-top';

class SearchList extends Component {
  static propTypes = {
    // 关键词
    keyword: PropTypes.string,
    // 状态，0没有数据，1加载中，2加载失败，3没有更多数据
    status: PropTypes.number,
    // 获取搜索结果数据
    getSearchList: PropTypes.func,
    // 搜索结果列表
    byIds: PropTypes.array,
  };

  constructor(props) {
    super(props);
    // 是否禁用滚动加载
    this.banScroll = false;
    // 关键字
    this.keyword = props.keyword;
  }

  componentDidMount() {
    // 分页展示，添加页面滚动监听
    window.addEventListener('scroll', throttle(this.handleScrollLoading, 100));
  }

  componentWillUnmount() {
    // 分页展示，取消滚动监听
    window.removeEventListener(
      'scroll',
      throttle(this.handleScrollLoading, 100)
    );
  }
  // 渲染搜索列表
  getSearchList = () => {
    const { keyword, status, byIds } = this.props;
    this.banScroll = false;

    // 没有数据,展示emptyTips和精选案例推荐
    if (status === 0 && !byIds.length) {
      this.banScroll = true;
      return (
        <div>
          <EmptyTip keyword={keyword ? keyword : 'YYY'} />
          <CaseList listType={1} />
        </div>
      );
    }
    // 加载中
    if (status === 1 && !byIds.length) {
      this.banScroll = true;
      return null;
    }

    return (
      <div className="common-wrap">
        <ul className="case-list">
          {byIds &&
            byIds.map(pageContent =>
              pageContent.map((v, i) => (
                <ListItem key={i} {...v} listType={2} />
              ))
            )}
        </ul>
        <div className="loading-status" ref={node => (this.trigger = node)}>
          <BottomStatus status={status} />
        </div>
      </div>
    );
  };
  // 获取搜索列表数据
  fetchSearchData = async () => {
    return await this.props.getSearchList();
  };

  // 滚动加载
  handleScrollLoading = () => {
    if (this.props.status !== 0 || !this.trigger) return false;

    const isTriggered = checkInViewport(this.trigger);
    if (!this.banScroll && isTriggered) {
      this.fetchSearchData();
    }
  };

  render() {
    // 屏幕高度
    const clientHeight = document.body.clientHeight;
    const storeTplStyle = {
      // 最小高度为iframe高度减去tab高度和marin高度
      minHeight: `${clientHeight - 24 - 50}px`,
    };

    return (
      <div style={storeTplStyle}>
        <div className="">{this.getSearchList()}</div>
        {/* <GotoTop /> */}
      </div>
    );
  }
}

export default SearchList;
